"use client"

import { motion } from "framer-motion"

const items = [
    {
        title: "Agentic",
        subtitle: "Fluent",
        description:
            "Claude Code, Codex, Opencode, Zed, Cursor. Years of daily use. I know which one to reach for, what to give it, and where each gets things wrong.",
        color: "text-emerald-700 dark:text-emerald-400",
    },
    {
        title: "Performance",
        subtitle: "Foundation",
        description:
            "Angular, Next.js, React, TypeScript. Clean architecture so the code still makes sense six months after launch, not just on day one.",
        color: "text-orange-700 dark:text-orange-400",
    },
    {
        title: "Experience",
        subtitle: "Polish",
        description:
            "I sweat the last 1%. Alignment, contrast, 60fps motion, keyboard-first navigation. Components that work the first time someone uses them.",
        color: "text-purple-700 dark:text-purple-400",
    },
]

export default function PassionateSectionMinimal() {
    return (
        <section className="container mx-auto px-4 py-24">
            {/* Section Header */}
            <div className="mb-16 flex items-center justify-between border-border/70 border-b pb-6 dark:border-border/40">
                <span className="font-mono text-muted-foreground text-xs uppercase tracking-widest">
                    Core Philosophy
                </span>
                <span className="font-mono text-muted-foreground text-xs uppercase tracking-widest">
                    03 · Attributes
                </span>
            </div>

            {/* Content */}
            <div className="flex flex-col">
                {items.map((item, index) => (
                    <motion.div
                        key={item.title}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{
                            delay: index * 0.1,
                            duration: 0.5,
                        }}
                        viewport={{ once: true }}
                        className="group relative border-border/70 border-b py-12 transition-all duration-500 hover:bg-zinc-50/50 dark:border-border/40 dark:hover:bg-zinc-900/50"
                    >
                        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
                            {/* Number & Title */}
                            <div className="flex flex-col gap-4 lg:col-span-5">
                                <span className="font-mono text-muted-foreground text-sm">
                                    {(index + 1).toString().padStart(2, "0")}
                                </span>
                                <h3 className="font-medium text-5xl text-foreground tracking-tighter md:text-7xl">
                                    {item.title}
                                </h3>
                            </div>

                            {/* Description */}
                            <div className="flex flex-col justify-end gap-8 lg:col-span-7">
                                <div className="max-w-2xl">
                                    <h4
                                        className={`mb-4 font-mono text-sm uppercase tracking-wider ${item.color}`}
                                    >
                                        {item.subtitle}
                                    </h4>
                                    <p className="font-light text-muted-foreground text-xl leading-relaxed">
                                        {item.description}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                ))}
            </div>
        </section>
    )
}
